/**
 * 後台會員搜尋框(手機 / 姓名 / Email,debounce 400ms,最多 10 筆)
 * 搜尋方式同 DirectShip;選到會員後清空輸入並呼叫 onPick,由呼叫端決定接下來顯示什麼。
 */
import { useEffect, useState } from "react";
import { listMembers } from "../api/admin";
import type { Member } from "../api/members";


export default function MemberSearchBox({
  onPick,
  placeholder = "輸入手機號碼(或姓名)搜尋",
  autoFocus = false,
}: {
  onPick: (m: Member) => void;
  placeholder?: string;
  autoFocus?: boolean;
}) {
  const [query, setQuery] = useState("");
  const [candidates, setCandidates] = useState<Member[]>([]);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    const q = query.trim();
    if (!q) {
      setCandidates([]);
      return;
    }
    // 清空輸入 / 換關鍵字後,舊請求晚到不能蓋掉新結果
    let cancelled = false;
    const t = setTimeout(async () => {
      setSearching(true);
      try {
        const r = await listMembers({ search: q, limit: 10 });
        if (!cancelled) setCandidates(r.members);
      } catch {
        // ignore
      } finally {
        if (!cancelled) setSearching(false);
      }
    }, 400);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [query]);

  function pick(m: Member) {
    setQuery("");
    setCandidates([]);
    onPick(m);
  }

  return (
    <div>
      <input
        className="input"
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
      />
      {searching && <div className="text-xs text-muted mt-2">搜尋中…</div>}
      {candidates.length > 0 && (
        <div className="mt-2 max-h-60 overflow-y-auto border border-line rounded-lg bg-white">
          {candidates.map((m) => (
            <button
              key={m.line_user_id}
              type="button"
              onClick={() => pick(m)}
              className="w-full text-left px-3 py-2 border-b border-line/50 last:border-0 hover:bg-cream/50"
            >
              <div className="text-sm">
                {m.name || m.display_name || "—"}
                {m.status === "suspended" && <span className="ml-2 text-xs text-coral">已停用</span>}
              </div>
              <div className="text-xs text-muted">{m.phone || "—"} · {m.email || "—"}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
